import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../../environments/environment";
import * as HSET from "./settings";
import { GenericHttpService } from "../../../services/generic-http.service";
import { Observable } from "rxjs";
import { GenericUtils } from "../../../utilities/generic-utils"
@Injectable()
export class DataService {
  baseUrl = environment.gateWayHost;
  editItem: any;

  constructor(
    public generic: GenericHttpService,
    private utils: GenericUtils
  ) { }

  getData(url, config, params): Observable<any> {
    const option = {
      method: "GET",
      url: `${this.baseUrl}${url}`,
      query: params
    };


    const functionToExecute = config.functionToCall ? this[config.functionToCall].bind(this) : this.getFunctionToExecute(config.id);
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(functionToExecute)
    );
  }

  getFunctionToExecute(id) {
    if (id === 26) {
      return this.processTATBreakUpData;
    }
    if (id === 31) {
      return this.processStatusBreakup;
    }
    if (id === 33) {
      return this.readyToDispatch;
    }
  }
 
  processTATBreakUpData(data: any): any {
    if (!Object.keys(data.data[0]).length) return null;

    const tat1 = [];
    const tat2 = [];
    const tat3 = [];
    const greaterThan3 = [];

    let dataKeys = [];
    let allKey = "All";
    let parentIndex = -1;
    let __v2Data = data.data[0].TransportationTATBreakupV2;
    let __v2DataWithoutDataKey = { ...__v2Data };
    delete __v2DataWithoutDataKey["data"];

    if (Object.keys(__v2DataWithoutDataKey).length > 1) {
      dataKeys = Object.keys(__v2Data);
    } else if (Object.keys(__v2DataWithoutDataKey).length === 1) {
      allKey = Object.keys(__v2Data)[0];
      __v2Data = __v2Data[Object.keys(__v2Data)[0]];
      dataKeys = Object.keys(__v2Data);
      __v2DataWithoutDataKey = { ...__v2Data };
      delete __v2DataWithoutDataKey["data"];
      if (Object.keys(__v2DataWithoutDataKey).length > 1) {
        dataKeys = Object.keys(__v2Data);
      } else if (Object.keys(__v2DataWithoutDataKey).length === 1) {
        allKey = Object.keys(__v2Data)[0];
        __v2Data = __v2Data[Object.keys(__v2Data)[0]];
        dataKeys = Object.keys(__v2Data);
      }
    }

    const columns = dataKeys.map((_dataName, index) => {
      let __data = {};
      if (_dataName === "data") {
        __data = __v2Data[_dataName];
      } else {
        __data = __v2Data[_dataName]["data"];
      }
      tat1.push(
        Number(
          (
            (__data["tat_1"] /
              (__data["tat_1"] +
                __data["tat_2"] +
                __data["tat_3"] +
                __data["tat_greater_3"])) *
            100
          ).toFixed(2)
        )
      );
      tat2.push(
        Number(
          (
            (__data["tat_2"] /
              (__data["tat_1"] +
                __data["tat_2"] +
                __data["tat_3"] +
                __data["tat_greater_3"])) *
            100
          ).toFixed(2)
        )
      );
      tat3.push(
        Number(
          (
            (__data["tat_3"] /
              (__data["tat_1"] +
                __data["tat_2"] +
                __data["tat_3"] +
                __data["tat_greater_3"])) *
            100
          ).toFixed(2)
        )
      );
      greaterThan3.push(
        Number(
          (
            (__data["tat_greater_3"] /
              (__data["tat_1"] +
                __data["tat_2"] +
                __data["tat_3"] +
                __data["tat_greater_3"])) *
            100
          ).toFixed(2)
        )
      );

      if (_dataName === "data") {
        parentIndex = index;
      }

      return _dataName === "data" ? allKey : _dataName;
    });

    tat1.splice(0, 0, tat1.splice(parentIndex, 1)[0]);
    tat2.splice(0, 0, tat2.splice(parentIndex, 1)[0]);
    tat3.splice(0, 0, tat3.splice(parentIndex, 1)[0]);
    greaterThan3.splice(0, 0, greaterThan3.splice(parentIndex, 1)[0]);

    columns.splice(0, 0, columns.splice(parentIndex, 1)[0]);

    const Alldata = [];
    const OneData = [];
    columns.forEach(ele => {
      if (ele === "All") {
        OneData.push(ele);
      } else {
        Alldata.push(ele);
      }
    });
    const categories = OneData.concat(Alldata);
    return [tat1, tat2, tat3, greaterThan3, categories];
  }

  processStatusBreakup(data: any): any {
    const allValues = []
    let categories = [];
    const statusKey = { "to_be_invoiced": "To Be invoiced" };
    const statusArray = ["to_be_invoiced"];
    // console.log(data.data);
    if (data.data.length === 0) return null;
    data.data.forEach(ele => {
      Object.keys(ele).forEach(elem => {
        if (statusArray.indexOf(elem) > -1) {
          categories.unshift(statusKey[elem])
          if (elem === "to_be_invoiced") {
            ele[elem].forEach(status => {
              allValues.unshift(status);
            })
          }
        }
      })
    });
    if (!allValues.length) return null;
    const output = [];
    allValues.forEach((item) => {
      const existing = output.filter((v, i) => {
        return v.interval == item.interval;
      });
      if (existing.length) {
        const existingIndex = output.indexOf(existing[0]);
        output[existingIndex].quantity = output[existingIndex].quantity.concat(item.quantity);
      } else {
        if (typeof item.quantity != 'string')
          item.quantity = [item.quantity];
        output.push(item);
      }
    });
    const color = [];
    const seriesName = [];
    output.forEach(item => {
      color.push(item.color);
      seriesName.push(item.interval);
    });

    categories = categories.length > 0 ? ["To Be invoiced"] : categories;
    const total = output.reduce((a, b) => a + (+b.quantity[0]), 0);
    if (!total) return null;
    return {
      originalData: [output[0].quantity, output[1].quantity, output[2].quantity, output[3].quantity, categories],
      additionalData: [color, seriesName]
    };
  }

  readyToDispatch(data: any): any {
    const allValues = []
    let categories = [];
    const statusKey = { "invoiced": "Ready to Dispatch" };
    const statusArray = ["invoiced"];
    // console.log(data.data);
    if (data.data.length === 0) return null;
    data.data.forEach(ele => {
      Object.keys(ele).forEach(elem => {
        if (statusArray.indexOf(elem) > -1) {
          categories.unshift(statusKey[elem])
          if (elem === "invoiced") {
            ele[elem].forEach(status => {
              allValues.unshift(status);
            })
          }
        }
      })
    });
    if (!allValues.length) return null;
    const output = [];
    allValues.forEach((item) => {
      const existing = output.filter((v, i) => {
        return v.interval == item.interval;
      });
      if (existing.length) {
        const existingIndex = output.indexOf(existing[0]);
        output[existingIndex].quantity = output[existingIndex].quantity.concat(item.quantity);
      } else {
        if (typeof item.quantity != 'string')
          item.quantity = [item.quantity];
        output.push(item);
      }
    });
    const color = [];
    const seriesName = [];
    output.forEach(item => {
      color.push(item.color);
      seriesName.push(item.interval);
    });

    categories = categories.length > 0 ? ["Ready to Dispatch"] : categories;
    const total = output.reduce((a, b) => a + (+b.quantity[0]), 0);
    if (!total) return null;
    return {
      originalData: [output[0].quantity, output[1].quantity, output[2].quantity, output[3].quantity, categories],
      additionalData: [color, seriesName]
    };
  }

  createChart(chartData, options) {
    const chart = this.utils.deepCopyFunction(HSET.chartData);

    if (!Array.isArray(chartData)) {
      options[0].legend.colorSet = chartData.additionalData[0];
      options[0].series.name = chartData.additionalData[1];
      chartData = chartData.originalData
    }

    chart.xAxis.categories = chartData[chartData.length - 1];
    chart.series = [];

    for (let i = 0; i < chartData.length - 1; i++) {
      const data = {
        name: "",
        data: chartData[i],
        index: i,
        stack: "male",
        color: "",
        tooltip: { valueSuffix: "" }
      }

      chart.series[i] = data;
    }

    if (options[0].xAxis) {
      // do nothing for now. This is just a provision for the future
    }

    if (options[0].yAxis) {
      for (let i = 0; i < options[0].yAxis.length; i++) {

        if (options[0].yAxis[i].min) {
          chart.yAxis[i].min = options[0].yAxis[i].min;
        }
        if (options[0].yAxis[i].max) {
          chart.yAxis[i].max = options[0].yAxis[i].max;
        }

        if (options[0].yAxis[i].title) {
          const TITLE = options[0].yAxis[i].title;
          if (TITLE.text) {
            chart.yAxis[i].title.text = TITLE.text;
          }
          if (TITLE.style) {
            // do nothing for now. This is just a provision for the future
          }
        }
        if (options[0].yAxis[i].label) {
          const LABEL = options[0].yAxis[i].label;
          if (LABEL.format) {
            chart.yAxis[i].labels.format = LABEL.format;
          }
          if (LABEL.style) {
            chart.yAxis[i].labels.style.fontSize = LABEL.style.fontSize;
            chart.yAxis[i].labels.style.fontWeight = LABEL.style.fontWeight;
            chart.yAxis[i].labels.style.color = LABEL.style.color;
          }
        }
      }
    }

    if (options[0].legend) {
      if (options[0].legend.style) {
        const STYLE = options[0].legend.style;
        chart.legend.itemStyle.fontSize = STYLE.fontSize;
        chart.legend.itemStyle.fontWeight = STYLE.fontWeight;
        chart.legend.itemStyle.color = STYLE.color;
      }

      if (options[0].legend.colorSet) {
        const COLORSET = options[0].legend.colorSet;
        const INDEX = options[0].series.index;
        for (let i = 0; i < COLORSET.length; i++) {
          chart.series[i].color = COLORSET[i];
          if (INDEX[i] || INDEX[i] === 0) {
            chart.series[i].index = INDEX[i];
          }
        }
      }
    }

    if (options[0].series) {

      if (options[0].series.name) {
        const NAMES = options[0].series.name;
        const TOOLTIP = options[0].series.tooltipSuffix ? options[0].series.tooltipSuffix : [];
        for (let i = 0; i < NAMES.length; i++) {
          chart.series[i].name = NAMES[i];
          if (TOOLTIP[i]) {
            chart.series[i].tooltip.valueSuffix = TOOLTIP[i];
          }
        }
      }
    }

    // chart.series[0].data = chartData.tat1;
    // chart.series[1].data = chartData.tat2;
    // chart.series[2].data = chartData.tat3;
    // chart.series[3].data = chartData.greaterThan3;

    return chart;
  }
}
